import Icon from '../components/Icon.vue'

Icon.register({
  cookie: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.4 254.8L498.3 178.5A132.5-132.5 0 0 1 461.1 105.6L406.4 50.8C386.6 31.1 361.2 18.1 333.7 13.8L257 1.6C229.5-2.7 201.3 1.7 176.4 14.4L107.3 49.6A132.3-132.3 0 0 1 49.5 107.4L14.4 176.3A132.6-132.6 0 0 1 1.6 257.2L13.7 333.5A132.5-132.5 0 0 1 50.9 406.4L105.6 461.2A132.1-132.1 0 0 1 178.3 498.2L255 510.4C282.5 514.7 310.7 510.3 335.5 497.6L404.7 462.4A132.3-132.3 0 0 1 462.4 404.6L497.6 335.8C510.3 310.8 514.8 282.4 510.4 254.8zM176 368C158.3 368 144 353.7 144 336S158.3 304 176 304 208 318.3 208 336 193.7 368 176 368zM208 208C190.3 208 176 193.7 176 176S190.3 144 208 144 240 158.3 240 176 225.7 208 208 208zM368 336C350.3 336 336 321.7 336 304S350.3 272 368 272 400 286.3 400 304 385.7 336 368 336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cookie.js
// module id = 3PeD
// module chunks = 144